import * as Sentry from '@sentry/browser';

declare let window: Window & {
  VITE_APP_SENTRY_DSN: string;
  VITE_APP_SENTRY_ENV: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const integrations: any[] = [
  Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
  Sentry.browserTracingIntegration()
];

if (!import.meta.env.DEV) {
  integrations.push(Sentry.captureConsoleIntegration());
}

export default {
  dsn: window.VITE_APP_SENTRY_DSN || import.meta.env.VITE_APP_SENTRY_DSN,
  environment: window.VITE_APP_SENTRY_ENV || import.meta.env.VITE_APP_SENTRY_ENV,
  integrations: integrations,
  release: import.meta.env.VITE_APP_SENTRY_RELEASE,
  replaysSessionSampleRate: 1.0,
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['https://localhost:7070', 'https://apigw-lumar.dev.solve-x.net']
} as Sentry.BrowserOptions;
